import { CircularProgress } from '@mui/material'

import {
  MessageBox,
  RadioTab,
  Section,
  SingleColumnView,
  Space,
  TabStrip,
  TradeTopup,
  ValidationMessage
} from '../../../../../components/core-v2'
import Icon from '../../../../../components/core-v2/atoms/Icon'
import IconButton from '../../../../../components/core-v2/molecules/iconButton'
import { WizardButtons } from '../../../../tradebuilder-v2/modules/00-builder/wizard-buttons'
import { CollateralAlert } from '../../../../tradebuilder-v2/util/Alerts'
import { TopUpWithdrawState } from '../../../types/TopUpWithdrawState'
import { TopupWithdrawStepState } from '../state/topup-withdraw-slice'

export type TradeTopupWithdrawStatelessProps = {
  isLoading?: boolean
  onChangeAmount: (updatedValue: number) => void
  onChangeSelection: (state: TopUpWithdrawState) => void
  onClose: () => void
  onCloseAll: () => void
  onSave: () => void
  state: TopupWithdrawStepState
}

const TradeTopupWithdrawStateless = ({
  isLoading = false,
  onChangeAmount,
  onChangeSelection,
  onClose,
  onCloseAll,
  onSave,
  state
}: TradeTopupWithdrawStatelessProps) => {
  const { closeAllTradesInNote, closeThisTrade, topUpWithrawState } = state
  const onTopup = (updatedValue: number) => {
    onChangeAmount(updatedValue)
  }
  const onWithdraw = (updatedValue: number) => {
    onChangeAmount(updatedValue)
  }
  const onTopupWithdrawSelection = (selectedState: TopUpWithdrawState) => {
    onChangeSelection(selectedState)
  }
  const onMoveNext = () => {
    onSave()
  }

  if (isLoading) {
    return (
      <SingleColumnView>
        <Section type="primary">
          <Space isflex alignItems="center" justifyContent="center" style={{ padding: '128px 0' }}>
            <CircularProgress color="inherit" size="1.5rem" />
          </Space>
        </Section>
      </SingleColumnView>
    )
  }

  return (
    <SingleColumnView>
      <Section type="primary">
        {state.errors && <ValidationMessage errors={state.errors} fieldName="approveError" />}
        <TabStrip>
          <RadioTab
            isSelected={topUpWithrawState === TopUpWithdrawState.UnDef}
            onClick={() => onTopupWithdrawSelection(TopUpWithdrawState.UnDef)}
          >
            Edit only
          </RadioTab>
          <RadioTab
            isSelected={topUpWithrawState === TopUpWithdrawState.Topup}
            onClick={() => onTopupWithdrawSelection(TopUpWithdrawState.Topup)}
          >
            Top up
          </RadioTab>
          <RadioTab
            isSelected={topUpWithrawState === TopUpWithdrawState.Withdraw}
            onClick={() => onTopupWithdrawSelection(TopUpWithdrawState.Withdraw)}
          >
            Withdraw
          </RadioTab>
        </TabStrip>
        {topUpWithrawState === TopUpWithdrawState.Topup && (
          <TradeTopup
            change={state.changeAmount}
            currency={state.currency}
            current={state.currentAmount}
            minChange={state.minTopupAmount}
            topupOrWithdrawal="topup"
            total={state.newBalance}
            onChange={updatedValue => onTopup(updatedValue)}
          />
        )}
        {topUpWithrawState === TopUpWithdrawState.Withdraw && (
          <TradeTopup
            change={state.changeAmount}
            currency={state.currency}
            current={state.currentAmount}
            minChange={state.minWithdrawAmount}
            topupOrWithdrawal="withdraw"
            total={state.newBalance}
            onChange={updatedValue => onWithdraw(updatedValue)}
          />
        )}
        {state.warningBanner && (
          <MessageBox state="warning" title={state.warningBanner.title}>
            {state.warningBanner.description}
          </MessageBox>
        )}
      </Section>
      {closeThisTrade && (
        <Space isflex justifyContent="flex-end" my={6}>
          <IconButton
            data-testid="withdraw_close_trade"
            disabled={!state.canSave}
            icon={<Icon name="circleX" size="medium" />}
            iconPosition="left"
            operationType="progress"
            text="Close trade"
            onClick={() => onClose()}
          />
        </Space>
      )}
      {closeAllTradesInNote && (
        <Space isflex justifyContent="flex-end" my={6}>
          <IconButton
            disabled={!state.canSave}
            icon={<Icon name="circleX" size="medium" />}
            iconPosition="left"
            operationType="progress"
            text="Close all trades"
            onClick={onCloseAll}
          />
        </Space>
      )}
      <CollateralAlert />
      {!closeThisTrade && !closeAllTradesInNote && (
        <WizardButtons canMoveBack={false} canMoveNext={state.canSave} onMoveNext={onMoveNext} />
      )}
    </SingleColumnView>
  )
}

export default TradeTopupWithdrawStateless
